module.exports = __webpack_public_path__ + "static/media/LOADER_06.e8544e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading_page/LOADER_06.png
// module id = 314
// module chunks = 0